import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="Mind Aspirants"
      productUrl="/products/mind-aspirant"
      title="Privacy Policy"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          <strong>Spurnest Techlabs</strong> developed the <strong>Mind Aspirants</strong> app. This Privacy Policy explains how we collect, use, and protect your information when you use the Service.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Information We Collect</SectionTitle>
        <List>
          <li><strong>Mobile number</strong> — for account registration and OTP verification.</li>
          <li><strong>Google account info</strong> — if you sign in with Google (name, email).</li>
          <li><strong>Quiz performance data</strong> — scores, rankings, game history, and points earned.</li>
          <li><strong>Device information</strong> — device model, OS version, IP address, and app version.</li>
          <li><strong>Advertising ID (GAID/IDFA)</strong> — used to serve ads through ad networks such as Google AdMob.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>How We Use Your Information</SectionTitle>
        <List>
          <li>To provide and operate the quiz platform.</li>
          <li>To process OTP verification and account authentication.</li>
          <li>To calculate rankings, distribute prizes, and maintain leaderboards.</li>
          <li>To serve personalized advertisements.</li>
          <li>To improve app performance and fix errors via analytics (e.g. Firebase).</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Third-Party Services</SectionTitle>
        <Paragraph>We use third-party services that may collect information:</Paragraph>
        <List>
          <li><strong>Google Sign-In</strong> — authentication</li>
          <li><strong>Google AdMob</strong> — advertising</li>
          <li><strong>Firebase Analytics</strong> — crash reporting and usage analytics</li>
          <li><strong>Payment processors</strong> — for entry fee transactions</li>
        </List>
        <Paragraph>Each third party operates under its own privacy policy.</Paragraph>
      </Section>

      {/* <Section>
        <SectionTitle>SMS & OTP</SectionTitle>
        <Paragraph>
          By providing your mobile number, you consent to receive OTP and transactional SMS messages for account verification and quiz notifications. See our{" "}
          <a href="/legal/dlt-sms-consent" tw="text-primary-500 font-semibold">DLT SMS Consent</a> page for registered template details.
        </Paragraph>
      </Section> */}

      <Section>
        <SectionTitle>Children's Privacy</SectionTitle>
        <Paragraph>
          Mind Aspirants is not directed at children under 13. Cash prize features require users to be 18 years or older. We do not knowingly collect data from children under 13. Contact us to request deletion.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Data Security & Deletion</SectionTitle>
        <Paragraph>
          Data is encrypted in transit. You may request deletion of your account and personal data by emailing{" "}
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          Spurnest Techlabs, Gandhinagar, Gujarat 382610, India.
          <br />
          Email: <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>
          <br />
          Phone: <a href="tel:+918460407942" tw="text-primary-500 font-semibold">+91 84604 07942</a>
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
